export const DSP_PROVIDER = {
  DSP_NAME: 'dsp-name',
  DSP_UUID: 'dsp-uuid',
};
